import React, { useState } from "react";
import analyseIcon from "../icons/trending_up-24px.svg";
import searchIcon from "../icons/search-24px.svg";

import PremiumButton from "./PremiumButton";
import PostSearch from "./PostSearch";
import UserSettings from "./UserSettings";
import Modal from "../components/Modal";
import { SearchModal } from "../components/Modal";
import FullSpanSearchModal from "./FullSpanSearchModal";
import { useNavigate, Link } from "react-router-dom";
import "./HeaderComponents.css";
// import { useNavigate } from "react-router-dom";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";
import { useMediaQuery } from "react-responsive";
import AnalyseModal from "../components/AnalyseModal";

function HeaderComponents(props) {
    const [isSearchModalActive, setIsSearchModalActive] = useState(false);
    const [isAnalyseModalActive, setIsAnalyseModalActive] = useState(false);

    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });
    // const [isPremium, setIsPremium] = useState(false);
    const navigate = useNavigate();
    const { is_premium, payment_status } = props.user;
    const user = props.user;
    const settings = props.settings;
    const { isFullSpanSearchModalActivated, isAnalyseModalActivated } =
        props.settings;

    // function onAnalyseClick(e) {
    //     e.preventDefault();
    //     commitLocalUpdate(environment, (store) => {
    //         const record = store.getRoot().getLinkedRecord("settings");
    //         record.setValue("{}", "tagData");

    //         record.setValue(false, "isBookmarkView");
    //         record.setValue(false, "isPostNoteView");
    //         record.setValue([], "filterTerms");
    //         record.setValue([], "selectedSentimentPostIds");
    //         record.setValue([], "selectedLeads");
    //         record.setValue(false, "isAdvancedSearch");
    //         record.setValue("", "hasPhrase");
    //         record.setValue("", "withoutWords");
    //         record.setValue("", "withWords");
    //         record.setValue("", "searchScope");
    //         record.setValue("", "searchTime");
    //     });

    //     if (payment_status === "active" || payment_status === "trialing") {
    //         navigate("/home/analyse");
    //     } else if (payment_status === "past_due") {
    //         navigate("/complete-payment");
    //     } else {
    //         navigate("/upgrade");
    //     }

    //     // if (is_premium) {
    //     //     navigate("/home/analyse");
    //     // } else if (payment_status === "past_due") {
    //     //     navigate("/complete-payment");
    //     // } else {
    //     //     navigate("/upgrade");
    //     // }
    // }

    function onSearchClick(e) {
        e.preventDefault();
        setIsSearchModalActive(true);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isFullSpanSearchModalActivated");

            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue("{}", "tagData");
        });
    }

    // function onModalAnalyseIconClick(e) {
    //     e.preventDefault();
    //     // setIsAnalyseModalActive(true);

    //     commitLocalUpdate(environment, (store) => {
    //         const record = store.getRoot().getLinkedRecord("settings");
    //         record.setValue(true, "isAnalyseModalActivated");
    //     });
    // }

    function onAnalyseNavButtonClick(e) {
        e.preventDefault();
        // setIsAnalyseModalActive(true);

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("{}", "tagData");

            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
        });

        if (payment_status === "active" || payment_status === "trialing") {
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(!props.isActivated, "isRightNavActivated");
            });
        } else if (payment_status === "past_due") {
            navigate("/complete-payment");
        } else {
            navigate("/upgrade");
        }
    }

    return (
        <div className={`header-components`}>
            <div className="header-actionable-components">
                {/* <div className="action-button-container"> */}
                {/*     <button */}
                {/*         onClick={onAnalyseClick} */}
                {/*         className="analyse-button action-button my-sixth-step" */}
                {/*     > */}
                {/*         {" "} */}
                {/*         <img src={analyseIcon} /> */}
                {/*     </button> */}
                {/* </div> */}


                {/* Analyze button */}

                {/* <div className="action-button-container"> */}
                {/*     <button */}
                {/*         onClick={onAnalyseNavButtonClick} */}
                {/*         className="analyse-button action-button my-sixth-step" */}
                {/*     > */}
                {/*         {" "} */}
                {/*         <img src={analyseIcon} /> */}
                {/*     </button> */}
                {/* </div> */}
                {payment_status === "cancelled" ||
                payment_status === "" ||
                payment_status === "incomplete" ? (
                    <div className="">
                        <PremiumButton target="/upgrade" />
                    </div>
                ) : null}
                <div className="element-btn-post-search my-seventh-step">
                    {props.view === "home" ? (
                        <div onClick={onSearchClick}>
                            <img src={searchIcon} alt="" />
                        </div>
                    ) : null}
                </div>
                {/*
					<div className="element-btn-refresh">
						{props.view === "home" ? (
							<img className="btn-refresh" src={refreshIcon} />
						) : null}
					</div>
				*/}

                <UserSettings settings={props.settings} user={props.user} />

                {isSmallScreen ? (
                    <div>
                        {isFullSpanSearchModalActivated ? (
                            <FullSpanSearchModal
                                isModalActive={true}
                                user={user}
                                settings={settings}
                            />
                        ) : null}
                    </div>
                ) : (
                    <div>
                        {isSearchModalActive ? (
                            <div>
                                <SearchModal
                                    title="Search Posts"
                                    actionButton="Search"
                                    setIsModalActive={setIsSearchModalActive}
                                    isModalActive={isSearchModalActive}
                                    user={props.user}
                                />
                            </div>
                        ) : null}

                        {isAnalyseModalActivated ? (
                            <div>
                                <AnalyseModal
                                    title="Analytics"
                                    actionButton="Click"
                                    setIsModalActive={setIsAnalyseModalActive}
                                    isModalActive={isAnalyseModalActivated}
                                    user={props.user}
                                />
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
}

export default HeaderComponents;
